import React from 'react'
import { ListGroup } from 'react-bootstrap';

export interface Props {
    receivers: string[];
}
const ListReceivers = (props: Props) => {
  return (
    <ListGroup variant="flush">{props.receivers.map((receiver, idx) => (<ListGroup.Item className="ps-0" key={idx}>{receiver}</ListGroup.Item>))}</ ListGroup>
  )
}

export default ListReceivers